import { IRootState } from '..';

export const SELECTOR_RESOLUTION_PLAYLIST = (state: IRootState) => state.Resolution.playlist;
export const SELECTOR_RESOLUTION = (state: IRootState) => state.Resolution.resolution;
